import { ApiError } from './api-error';

class ApiErrorArray extends Error {
  status: number | null;

  errors: ApiError[] | [];

  constructor(params: ApiErrorArray) {
    super();
    this.errors = params.errors;
    this.status = params.status;
    /*
        We need to set the prototype manually since Babel and other transpilers have trouble
        setting prototypes when extending native classes like `Error`. You can read
        more here: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work.
        That documentation is of Typescript, but seems like the issue is from Babel,
        not Typescript itself.

        Since we want to support somewhat older browsers (IE 11 for instance) we can't use
        any known workarounds for this, so we manually set a name on the error we can use.
      */
    Object.setPrototypeOf(this, ApiErrorArray.prototype);
  }
}

export { ApiErrorArray };
